import apiClient from '../api-client';

export default {
	async getLoanDropDownOptions() {
		let options = {};
		const dropDownOptionsUrls = [
			'/Loan/GetAllAmortizationTypes',
			'/Loan/GetAllCommitmentTypes',
			'/Loan/GetAllLoanPurposeTypes',
			'/Loan/GetAllLoanTypes',
			'/Loan/GetAllOccupancyTypes',
			'/Loan/GetAllPropertyTypes',
			'/Loan/GetAllLienPositions',
		];

		const getLabel = (lableId) => {
			switch (lableId) {
				case 'amortizationTypeId':
					return 'amortizationTypes';
				case 'commitmentTypeId':
					return 'commitmentTypes';
				case 'purposeId':
					return 'loanPurposeTypes';
				case 'typeId':
					return 'loanTypes';
				case 'occupancyTypeId':
					return 'occupancyTypes';
				case 'propertyTypeId':
					return 'propertyTypes';
				case 'lienPositionId':
					return 'lienPositions';
			}
		};

		const buildOptions = (label, value) => {
			// if key for label does not exist creates empty array at key
			options[label] || (options[label] = []);
			options[label].push(value);
		};

		const getTypes = async () => {
			let types = await Promise.all(
				dropDownOptionsUrls.map((link) => apiClient().get(link)),
			);
			return types;
		};

		await (
			await getTypes()
		).forEach(({ data }) => {
			data.map((item) => {
				const [idProp, nameProp] = Object.keys(item);
				const label = getLabel(idProp);
				buildOptions(label, {
					id: item[idProp],
					value: item,
					name: item[nameProp],
				});
			});
		});

		return options;
	},
};
